<script>

    import { fade } from 'svelte/transition';
    import {link , push} from 'svelte-spa-router'
    import fetchData from '../../api.js';
    import UserStore from '../../stores/user';
    import { validateFields }  from '../../base/validation.js';
    import { _ } from "svelte-i18n";
    import { onMount } from 'svelte';
    import Header from '../../components/Header.svelte'; 
    import TopInfo from '../../components/TopInfo.svelte';  
    import Preloader from '../../components/Preloader.svelte'; 
    import ToolTip from '../../components/ToolTip.svelte'; 

    let isLoading = false;


    // For now using local values – later replace with store / API calls
    let feed = {};
    let zap = {
        isActive: false,
        intervalHours: 24,
        selectedCategories: [],
        shipping_price: 0,
        shipping_time: 7
    };

    let availableCategories = [];

    

    $: nextGeneration = feed.date
        ? (() => {
            const d = new Date(new Date(feed.date).getTime() + zap.intervalHours * 60 * 60 * 1000);

            return d.getFullYear() + '-' +
                String(d.getMonth() + 1).padStart(2, '0') + '-' +
                String(d.getDate()).padStart(2, '0') + ' ' +
                String(d.getHours()).padStart(2, '0') + ':' +
                String(d.getMinutes()).padStart(2, '0') + ':' +
                String(d.getSeconds()).padStart(2, '0');
        })()
        : 'N/A';

    onMount(() => {
        // → Fetch initial data for the feed settings here (feedLink, isActive, intervalHours, lastGenerated, nextGeneration, availableCategories)
        // For now, we'll use hardcoded values for demonstration
        fetchSettings();
    });

    async function fetchSettings() {
        isLoading = true;

        try {
            let postData = {
                action: 'fetch_feed_settings',
                token: $UserStore.api_token,
                merchant_id: $UserStore.merchant_id,
                app_id : $UserStore.app_id,
                url: appBaseUrl
                // Include any other necessary data here
            };
            
            let response = await fetchData(postData);

            // Assuming the response structure matches the following:
            feed = response?.feed  || {};
            if (typeof response?.zap?.isActive === 'undefined') {
                
            } else {
                zap = response?.zap || zap;
            }
            availableCategories = response?.categories || [];

        } catch (e) {
            alert('Failed to fetch feed settings');
        } finally {
            isLoading = false;
        }
    }

    async function saveSettings() {
        isLoading = true;

        try {
            let postData = {
                action: 'save_feed_settings',
                token: $UserStore.api_token,
                merchant_id: $UserStore.merchant_id,
                app_id : $UserStore.app_id,
                url: appBaseUrl,
                zap : zap
                // Include any other necessary data here
            };
            
            let response = await fetchData(postData);

            // Assuming the response structure matches the following:
            feed = response?.feed  || {};
            zap = response?.zap || zap;
            availableCategories = response?.categories || [];

            fetchSettings(); // Refresh settings after saving

        } catch (e) {
            alert('Failed to fetch feed settings');
        } finally {
            isLoading = false;
        }
    }

    function handleIntervalChange() {
        if (intervalHours < 1) {
        intervalHours = 1;
        }
    }


    function copyLink() {
        const textarea = document.createElement('textarea');
        textarea.value = feed.link;
        textarea.style.position = 'fixed';
        textarea.style.opacity = '0';

        document.body.appendChild(textarea);
        textarea.select();

        try {
            document.execCommand('copy');
            alert('Feed link copied to clipboard!');
        } catch (err) {
            alert('Copy failed');
        }

        document.body.removeChild(textarea);
    }


    async function generateNewFeed() {
        isLoading = true;

        try {
            let postData = {
                action: 'generate_feed',
                token: $UserStore.api_token,
                merchant_id: $UserStore.merchant_id,
                app_id : $UserStore.app_id,
                url: appBaseUrl
                // Include any other necessary data here
            };
            
            await fetchData(postData)

            alert('Feed generated successfully!');
        } catch (e) {
            alert('Failed to generate feed');
        } finally {
            isLoading = false;
        }
    }


</script>


<div class="page-container" transition:fade={{ delay: 250, duration: 300 }}>
    <Preloader {isLoading}/>
    <!-- <Header /> -->
    <div class="page">    
        <TopInfo/>
        <div class="shipment">  
            <div class="max-w-3xl mx-auto px-6 py-12">
            <h1 class="text-4xl font-bold text-center mb-10 text-gray-800">
                {$_('zap.zap_feed_welcome_message')}
            </h1>

            <div class="bg-white rounded-xl shadow-sm border border-gray-200 p-8 mb-8 text-center">
                <p class="text-xl text-gray-600 mb-6">
                    {$_('zap.zap_feed_shared_link')}

                <div class="flex flex-col sm:flex-row items-center gap-4 bg-gray-50 p-4 rounded-lg border border-gray-200 mb-4">
                    <code class="text-gray-800 font-mono break-all flex-1 text-left dir-ltr">
                        {feed.link || $_('zap.zap_feed_no_link_available')}
                    </code>
                    <button
                        on:click={copyLink}
                        class="bg-blue-600 hover:bg-blue-700 text-white px-5 py-2 rounded-lg font-medium transition-colors"
                    >
                        {$_('zap.zap_feed_copy_button')}
                    </button>
                </div>

                <p class="text-gray-500 text-sm mb-4">
                {$_('zap.zap_feed_share_link_info')}
                </p>

                <!-- Moved timing info here – right under the link -->
                <div class="bg-blue-50 p-5 rounded-lg border border-blue-100 mb-6">
                    <p class="text-gray-700">
                        {$_('zap.zap_feed_last_generation')}: <strong>{feed.date || 'N/A'}</strong>
                    </p>
                    <p class="text-gray-700 mt-1">
                        {$_('zap.zap_feed_next_generation')}: <strong>{nextGeneration}</strong>
                    </p>

                    <button
                        on:click={generateNewFeed}
                        disabled={isLoading}
                        class="mt-4 bg-blue-600 hover:bg-blue-700 disabled:opacity-50 text-white px-6 py-2 rounded-lg font-medium transition-colors"
                    >
                        {isLoading ? $_('zap.zap_feed_generating') : $_('zap.zap_feed_generate_new_feed_button')}
                    </button>
                </div>


            </div>

            <div class="bg-white rounded-xl shadow-sm border border-gray-200 p-8">
                <h2 class="text-2xl font-semibold mb-6 text-gray-800">{$_('zap.zap_feed_settings')}</h2>

                <div class="space-y-6">
                <!-- Active toggle -->
                <div class="flex items-center gap-3">
                    <input
                    type="checkbox"
                    id="active"
                    bind:checked={zap.isActive}
                    class="w-5 h-5 text-blue-600 rounded border-gray-300 focus:ring-blue-500"
                    />
                    <label for="active" class="text-gray-700 font-medium">
                    {$_('zap.zap_feed_active_label')}
                    </label>
                </div>

                <!-- Interval -->
                <div class="flex flex-col sm:flex-row sm:items-center gap-3">
                    <label class="text-gray-700 font-medium">
                    {$_('zap.zap_feed_generation_interval_label')}
                    </label>
                    <div class="flex items-center gap-2">
                    <input
                        type="number"
                        min="1"
                        bind:value={zap.intervalHours}
                        on:input={handleIntervalChange}
                        class="w-24 px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                    />
                    <span class="text-gray-700">{$_('zap.zap_feed_hours')}</span>
                    </div>
                    <span class="text-gray-500 text-sm">({$_('zap.zap_feed_minimum_interval')})</span>
                </div>

                <!-- Shipping price -->
                <div class="flex flex-col sm:flex-row sm:items-center gap-3">
                    <label class="text-gray-700 font-medium">
                    {$_('zap.zap_feed_generation_price_label')}
                    </label>
                    <div class="flex items-center gap-2">
                    <input
                        type="number"
                        min="1"
                        bind:value={zap.shipping_price}
                        class="w-24 px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                    />
                    </div>
                </div>

                <!-- Shipping Time -->
                <div class="flex flex-col sm:flex-row sm:items-center gap-3">
                    <label class="text-gray-700 font-medium">
                    {$_('zap.zap_feed_generation_time_label')}
                    </label>
                    <div class="flex items-center gap-2">
                    <input
                        type="number"
                        min="1"
                        bind:value={zap.shipping_time}
                        class="w-24 px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                    />
                    </div>
                </div>

                <!-- Categories -->
                <div>
                    <label class="block text-gray-700 font-medium mb-2">
                    {$_('zap.zap_feed_filter_by_categories')}
                    </label>
                    <div class="flex flex-wrap gap-2">
                    {#each availableCategories as cat}
                        <label
                        class="inline-flex items-center px-4 py-2 rounded-full bg-gray-100 hover:bg-gray-200 transition-colors cursor-pointer text-sm"
                        >
                        <input
                            type="checkbox"
                            value={cat.external_id}
                            bind:group={zap.selectedCategories}
                            class="w-4 h-4 text-blue-600 rounded border-gray-300 mr-2 focus:ring-blue-500 mx-1"
                        />
                        {cat.name}
                        </label>
                    {/each}
                    </div>
                </div>

                <!-- Save button -->
                <button
                    on:click={saveSettings}
                    class="w-full sm:w-auto bg-green-600 hover:bg-green-700 text-white px-8 py-3 rounded-lg font-medium transition-colors mt-4"
                >
                    {$_('zap.zap_feed_save_button')}
                </button>
                </div>
            </div>
            </div>
        </div>
    </div>
</div>
